"use client";
import Image from "next/image";
import React, { useEffect } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { getStrapiMedia } from "../lib/api-helpers";

gsap.registerPlugin(ScrollTrigger);

interface Picture {
  data: {
    id: string;
    attributes: {
      url: string;
      name: string;
      caption: string;
      alternativeText: string;
    };
  };
}

interface PlatformsProps {
  data: {
    headingPlatform: string;
    platforms: {
      name: string;
      source: Picture;
    }[];
  };
}

const Platforms = ({ data }: PlatformsProps) => {
  useEffect(() => {
    const platformItems = gsap.utils.toArray<HTMLElement>(".data-platform");
    const categoryItems = gsap.utils.toArray<HTMLElement>(
      ".data-catagory .flex > div"
    );

    {platformItems.length && gsap.fromTo(
      platformItems,
      { opacity: 0, transform: "scale(0.8)" },
      {
        opacity: 1,
        transform: "scale(1)",
        scrollTrigger: {
          trigger: platformItems,
          start: "top 70%",
          end: "bottom 20%",
          toggleActions: "restart none none reverse",
        },
      }
    );}

    {categoryItems.length && gsap.fromTo(
      categoryItems,
      { opacity: 0, transform: "scale(0.8)" },
      {
        opacity: 1,
        transform: "scale(1)",
        scrollTrigger: {
          trigger: categoryItems,
          start: "top 70%",
          end: "bottom 20%",
          toggleActions: "restart none none reverse",
        },
      }
    );}
  }, []);

  return (
    <div className='flex flex-col items-center justify-center bg-white pt-[80px] lg:pt-[120px] pb-[48px] lg:pb-[72px]'>
      <h2 className='text-[#032d60] subheading mb-[48px] text-5xl xl:text-6xl text-center font-bold w-full mx-auto px-10 xl:p-0'
      dangerouslySetInnerHTML={{ __html: data.headingPlatform }}></h2>
      <div className='w-full justify-center lg:flex xl:max-w-[1336px] mx-auto px-[24px] lg:px-0'>
        <div
          className='grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 p-[24px] xl:p-[32px] rounded-[36px] lg:rounded-[94px]'
          style={{ backgroundColor: "rgba(219, 242, 255, 0.5)" }}>
          {data.platforms.map((platform, index) => {
            const imageUrl = getStrapiMedia(
              platform.source.data.attributes.url
            );
            return (
              <div
                key={index}
                className='flex flex-col items-center justify-start p-[10px] xl:p-[32px] my-[16px] data-platform w-full relative'>
                <Image
                  className='object-contain h-[60px] md:h-[64px] w-auto mb-[20px] md:mb-[25px]'
                  src={imageUrl ?? ""}
                  width={100}
                  height={100}
                  alt={platform.name}
                  loading="lazy"
                />
                <p className='text-center mx-auto leading-[1.4] text-xl md:text-lg text-[#001630] font-medium' dangerouslySetInnerHTML={{ __html: platform.name }} />
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Platforms;
